export default __webpack_public_path__ + "static/media/cabine-pgto.1451a9f2.svg";